import { Col, DatePicker, Form, Input, Radio, Row, Select } from "antd";
import React, { FC, useEffect, useState } from "react";
import { IFetchAllDetails } from "../../../../../interfaces/IPatient";

type MemberProps = {
  formattedAdmissionType: Array<{ label: string; value: string }>;
  formattedPatientDiagnosed: Array<{ label: string; value: string }>;
  medcoDoctors: any;
  form: any;
  portalData: any;
  patientStore: IFetchAllDetails | null;
  isApproved: boolean;
};

const Member: FC<MemberProps> = (props) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const diagnosedBy = Form.useWatch("patientDiagnosedBy", props?.form);
  const isNewBorn = Form.useWatch("newBorn", props?.form);

  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
        }}
      >
        Member Details
      </div>
      <Form
        form={props?.form}
        //   onFinish={handleSubmit}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="BENEFICIARY ID"
              name="beneficiaryId"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input BENEFICIARY ID",
                },
              ]}
            >
              <Input
                placeholder="Please input BENEFICIARY ID"
                style={{ color: "black" }}
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="IPD/OPD NO"
              name="patientOpdIpdNumber"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input Patient Ipd/Opd Number",
                },
              ]}
            >
              <Input
                placeholder="Please input Patient Ipd/Opd Number"
                style={{ color: "black" }}
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="ADMISSION TYPE"
              name="visitType"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please select ADMISSION TYPE",
                },
              ]}
            >
              <Select
                showSearch
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                placeholder="Select a ADMISSION TYPE"
                options={props?.formattedAdmissionType?.map((option) => ({
                  value: option?.value + "~" + option?.label,
                  label: option?.label,
                }))}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="PATIENT DIAGNOSED BY"
              name="patientDiagnosedBy"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please select PATIENT DIAGNOSED BY",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a PATIENT DIAGNOSED BY"
                options={props?.formattedPatientDiagnosed?.map((option) => ({
                  value: option?.value,
                  label: option?.label,
                }))}
                allowClear
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col>

          {diagnosedBy?.toUpperCase() === "MEDCO" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="DOCTOR"
                name="doctor"
                style={{ color: "#575757" }}
                rules={[
                  {
                    required: true,
                    message: "Please select Doctor",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select a Doctor"
                  options={props?.medcoDoctors?.map((option: any) => ({
                    value: option?.doctorCode + "~" + option?.doctorName,
                    label: option?.doctorName,
                  }))}
                  allowClear
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          {diagnosedBy?.toUpperCase() === "OTHERS" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="IP DOCTOR NAME"
                name="ipDoctorName"
                style={{ color: "#575757" }}
                rules={[
                  {
                    required: true,
                    message: "Please input IP Doctor Name",
                  },
                  {
                    pattern: /^[a-zA-Z\s]*$/,
                    message: "Only alphabets and spaces are allowed",
                  },
                ]}
              >
                <Input
                  placeholder="Please input IP Doctor Name"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          {diagnosedBy?.toUpperCase() === "OTHERS" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="IP QUALIFICATION"
                name="ipQualification"
                style={{ color: "#575757" }}
                // rules={[
                //   {
                //     required: true,
                //     message: "Please input IP QUALIFICATION",
                //   },
                // ]}
              >
                <Input
                  placeholder="Please input IP QUALIFICATION"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          {diagnosedBy?.toUpperCase() === "OTHERS" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="IP REG. NO"
                name="ipRegistrationNo"
                style={{ color: "#575757" }}
                // rules={[
                //   {
                //     required: true,
                //     message: "Please input Ip Reg. No",
                //   },
                // ]}
              >
                <Input
                  placeholder="Please input Ip Reg. No"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          {diagnosedBy?.toUpperCase() === "OTHERS" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="IP CONTACT"
                name="ipContactNo"
                style={{ color: "#575757" }}
                rules={[
                  {
                    pattern: /^[6-9]/,
                    message: "Number start with 6, 7, 8, or 9!",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "Number must be 10 digits!",
                  },
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message: "Numeric values are allow!",
                  },
                ]}
                // rules={[
                //   {
                //     required: true,
                //     message: "Please input Ip Contact No",
                //   },
                // ]}
              >
                <Input
                  placeholder="Please input Ip Contact No"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                  maxLength={10}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="PROPOSED SURGERY/TREATMENT DATE"
              name="proposedDate"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input PROPOSED SURGERY/TREATMENT DATE",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={dateFormat}
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="IS NEW BORN BABY?"
              name="newBorn"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select new born",
                },
              ]}
            >
              <Radio.Group
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                options={[
                  { label: "YES", value: "true" },
                  { label: "NO", value: "false" },
                ]}
              />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="MEDICO LEGAL CASE"
              name="isMedicoLegalCase"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select medico legal case",
                },
              ]}
            >
              <Radio.Group
                options={[
                  { label: "YES", value: "true" },
                  { label: "NO", value: "false" },
                ]}
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="PROCEDURE CONSENT"
              name="procedureConsent"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select Procedure Consent",
                },
              ]}
            >
              <Radio.Group
                options={[
                  { label: "YES", value: "true" },
                  { label: "NO", value: "false" },
                ]}
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col>

          {isNewBorn === "true" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="REMARKS/NEW BORN BABY"
                name="newBornBabyRemarks"
                style={{ color: "#575757" }}
                rules={[
                  {
                    required: true,
                    message: "Please input remarks of new born baby",
                  },
                ]}
              >
                <Input
                  placeholder="Please input remarks of new born baby"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )} */}

          {(props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CAPF" || props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CAPF NEW") ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="REMARKS"
                name="remarks"
                style={{ color: "#575757" }}
              >
                <Input
                  placeholder="Please input remarks"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}
        </Row>
      </Form>
    </>
  );
};

export default Member;
